import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';  


@Injectable({
  providedIn: 'root'
})
/**
 * Service to manage the application's theme.
 * This service allows dynamically loading and switching CSS themes by manipulating link elements in the document head.
 */
export class ThemeService {
  private currentThemeLinkElement: HTMLLinkElement | null = null;

  constructor(
    @Inject(DOCUMENT) private document: Document  
  ) {}

  /**
   * Loads a CSS theme by dynamically creating a link element and appending it to the document head.
   * If a theme is already loaded, it removes the existing theme before loading the new one.
   *
   * @param themeUrl - The URL of the CSS file to load.
   */
  loadTheme(themeUrl: string): void {
    if (this.currentThemeLinkElement) {
      this.document.head.removeChild(this.currentThemeLinkElement);
    }

    const linkElement = this.document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = themeUrl;
    this.document.head.appendChild(linkElement);
    this.currentThemeLinkElement = linkElement;
  }

  /**
   * Initializes the theme by loading the specified CSS theme file.
   * Returns a promise that resolves when the theme is successfully loaded, or rejects if an error occurs.
   *
   * @returns A promise that resolves when the theme is successfully loaded.
   */
  initializeTheme(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        this.loadTheme('xcdrs-material-theme.css'); // Adjust the path as needed
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
}
